<div>
	@if (rotor) {
	<div class="row">
		<label class="col-md-2 col-form-label-sm">Operation:</label>
		@if (!multiOps) {
		<div class="col-md-6">
			@if (operations !== undefined) {
			<select class="form-control form-control-sm op-list" [(ngModel)]="operation" (ngModelChange)="refreshRegimeCounts()"
				title="Only showing {{ operations && operations.length >= RECENT_OPERATIONS_LIMIT ? 'latest ' + RECENT_OPERATIONS_LIMIT + ' ' : '' }}operations with vibe data for rotor '{{rotor.rotorid}}'">
				@for (operation of operations; track operation) {
				<option [ngValue]="operation" [class]="GetOpClass(operation)">
					{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}{{operation.rotor_turn_time |
					runtime : " Rotor: "}}{{operation.flight_time | runtime : " Flight: "}}{{operation.exceedance_count > 0 ? "
					Ex: " + operation.exceedance_count : ""}}
				</option>
				}
			</select>
			}
			@if (operations === undefined) {
			<select class="form-control form-control-sm" disabled>
				<option>Loading RTB operations...</option>
			</select>
			}
		</div>
		}
		@if (multiOps) {
		<div class="col-md-6">
			@if (operations !== undefined) {
			<select class="form-control form-control-sm" [(ngModel)]="multiOperation" (ngModelChange)="refreshRegimeCounts()"
				title="Only showing {{ operations && operations.length >= RECENT_OPERATIONS_LIMIT ? 'latest ' + RECENT_OPERATIONS_LIMIT + ' ' : '' }}operations with vibe data for rotor '{{rotor.rotorid}}'" multiple>
				@for (operation of operations; track operation) {
				<option [ngValue]="operation">
					{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</option>
				}
			</select>
			}
			@if (operations === undefined) {
			<select class="form-control form-control-sm" disabled multiple>
				<option>Loading RTB operations...</option>
			</select>
			}
		</div>
		}
		<div class="col-md-4">
			<label class="col-form-label-sm">
				<input [(ngModel)]="multiOps" type="checkbox" (ngModelChange)="refreshRegimeCounts()">
				Multiple operations
			</label>
			@if (multiOps) {
			<p>Ctrl+click to select multiple operations, 5 maximum</p>
			}
		</div>
	</div>
	}

	@if (regimeCounts !== undefined && regimeCounts.length === 0) {
	<div class="loading-status">
		No balance data is available for the selected operation
	</div>
	}

	@if (operations && operations.length === 0) {
	<div class="loading-status">
		No operations with vibe data are available
	</div>
	}

	@if (operations && operations.length > 0 && regimeCounts === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading operation data...
	</div>
	}

	@if (regimeCounts !== undefined && regimeCounts.length > 0) {
	<div class="row">
		<div class="col-lg-4">
			<div class="panel constrain">
				<div class="heading">Regimes</div>
				<div class="content nopad">
					<table class="log openborders paneled regimes">
						<thead>
							<tr>
								<th># Acq</th>
								<th>Regime</th>
								<th>Evaluate</th>
							</tr>
						</thead>
						@for (regime of regimeCounts; track regime) {
						<tbody class="regime">
							<tr>
								<td>{{regime.count}}</td>
								<td>{{regime.name}}</td>
								<td>
									<input type="checkbox" [(ngModel)]="regime.evaluate" (ngModelChange)="regimesChange()">
								</td>
							</tr>
						</tbody>
						}
					</table>
				</div>
			</div>
			@if (rotor.balancedata && rotor.balancedata.numblades >= 4 && !rotor.balancedata.oneperrev) {
			<div>
				<div class="row mt-2">
					<div class="col-4">
						Shaft Order
					</div>
					<div class="col-8">
						<div class="form-check form-check-inline">
							<label>
								<input [(ngModel)]="shaftOrder" type="radio" [value]="1" (ngModelChange)="updatePlot()"> 1/rev
							</label>
						</div>
						<div class="form-check form-check-inline">
							<label>
								<input [(ngModel)]="shaftOrder" type="radio" [value]="2" (ngModelChange)="updatePlot()"> 2/rev
							</label>
						</div>
					</div>
				</div>
				<div class="row mt-2">
					<div class="col-4">
						1/rev Only
					</div>
					<div class="col-8">
						<div class="form-check form-check-inline">
							<label>
								<input type="checkbox" [(ngModel)]="onePerRevOnly" (ngModelChange)="updatePlot()">
							</label>
						</div>
					</div>
				</div>
			</div>
			}
			@if (selectedRegimes && selectedRegimes.length && isH60) {
			<div class="panel mt-3">
				<div class="heading">Current Adjustments</div>
				<div class="content">
					<p>Valid H60 adjustments are 0, L, H, LL, LH, HH</p>
					<form #crtAdjForm="ngForm">
						<table class="adjustments">
							<tr>
								<th></th>
								@for (blade of rotor.blade; track blade) {
								<th>{{blade.name}}</th>
								}
							</tr>
							<tr>
								<th>
									<span>{{ rotor.adjdef[0].name }}:</span>
								</th>
								@for (blade of rotor.blade; track blade; let j = $index) {
								<td>
									<input [(ngModel)]="crtAdj[j]" (keyup.enter)="updatePlot()" type="text" [name]="'crtAdj' + blade.name" class="adj-entry" pattern="(?:0|[lL][lLhH]?|[hH]{1,2})">
								</td>
								}
							</tr>
							<tr class="divider">
								<th></th>
							</tr>
						</table>
					</form>
				</div>
			</div>
			}
			@if (selectedRegimes && selectedRegimes.length) {
			<div class="panel mt-3">
				<div class="heading">{{ isH60 ? 'New ' : '' }}Adjustments</div>
				<div class="content">
					<form #adjustmentForm="ngForm">
						<table class="adjustments">
							@for (adjdef of rotor.adjdef; track adjdef; let i = $index) {
							<!-- Display heading for every "display group" -->
							@if (i === 0 || adjdef.displaygroup !== rotor.adjdef[i-1].displaygroup) {
							<tr>
								<th></th>
								@for (blade of FilterBlades(adjdef.displaygroup); track blade) {
								<th>{{blade.name}}</th>
								}
							</tr>
							}
							<tr>
								<th>
									<a [hidden]="!alternates || !alternates[i].length" (click)="adjDetail[i] = !adjDetail[i]" href="javascript:void(0)" class="nowrap">{{ adjdef.name }} &#9662;</a>
									<span [hidden]="alternates && alternates[i].length">{{ adjdef.name }}:</span>
								</th>
								@for (blade of FilterBlades(adjdef.displaygroup); track blade; let j = $index) {
								<td>
									@if (adjustments && isH60) {
									<input [(ngModel)]="adjustments[i][j]" (keyup.enter)="ManualAdjustment()" type="text" [name]="'adj' + i + '_' + j" class="adj-entry"
										pattern="(?:0|[lL][lLhH]?|[hH]{1,2})">
									}
									@else if (adjustments && !isH60) {
									<input [(ngModel)]="adjustments[i][j]" (keyup.enter)="ManualAdjustment()" type="number" [name]="'adj' + i + '_' + j" class="adj-entry">
									}
								</td>
								}
								@if (adjustmentSelect.length > 1) {
								<th>
									<input [(ngModel)]="adjustmentSelect[i]" type="checkbox" [name]="'adjSelect' + i" (ngModelChange)="updatePlot()">
								</th>
								}
							</tr>
							@if (alternates) {
							@for (alt of alternates[i]; track alt; let altIdx = $index) {
							<tr (click)="SetAdjustment(i, altIdx)" [hidden]="!adjDetail[i]" class="alt-row">
								<th></th>
								@for (blade of FilterBlades(adjdef.displaygroup); track blade; let j = $index) {
								<td>
									@if (adjustments) {
									<div>{{this.isH60 ? alt[j] : (alt[j] | number : "1.0-1")}}</div>
									}
								</td>
								}
								<th></th>
							</tr>
							}
							}
							<tr class="divider">
								<th></th>
							</tr>
							}
						</table>
					</form>
					<button [disabled]="this.api.user.role === 'readonly'" (click)="RecordAdjustment()" class="button block">Record adjustment</button>
				</div>
			</div>
			}
		</div>
		@if (errormessage) {
		<div class="col-lg-8 mt-3">
			<app-dvs-chart [error]="errormessage" [height]="'600px'"></app-dvs-chart>
		</div>
		}
		@if (vshafts && vshafts.length && !errormessage) {
		<div class="col-lg-8 mt-3">
			<div class="bubble-tabs mt-0">
				@for (vshaft of vshafts; track vshaft) {
				<a class="bubble-tab" [routerLink]="[vshaft.id]" routerLinkActive="selected">{{ vshaft.name }}</a>
				}
			</div>
			<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>
			@if (trackOptions) {
			<div class="panel">
				<div class="heading">Blade track</div>
				<div class="content">
					<app-dvs-chart [options]="trackOptions" [height]="'400px'"></app-dvs-chart>
					@if (trackOptions) {
					<div class="chart-legend">
						<span class="legend-item">
							<span class="swatch square"></span> Averages
						</span>
						<span class="legend-item">
							<span class="swatch diamond"></span> Predictions
						</span>
					</div>
					}
				</div>
			</div>
			}
		</div>
		}
	</div>
	}
</div>